import { Component, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/app.service';
import { TipoDocumentosService } from 'src/app/services/tipo-documentos.service';
import { DadosCargasService } from 'src/app/services/dados-cargas.service';

@Component({
    selector: 'app-modal-atualiza-tipo-documentos',
    templateUrl: './modal-atualiza-tipo-documentos.component.html',
    providers: [TipoDocumentosService]
})

export class ModalAtualizaTipoDocumentosComponent implements OnInit {

    modalRef: NgbModalRef;
    public tipoDocumento: any;

    constructor(
        private appService: AppService,
        private tipoDocumentosService: TipoDocumentosService,
        private spinner: NgxSpinnerService,
        public toastrService: ToastrService,
        private dadosCargasService: DadosCargasService
    ) { }

    ngOnInit(): void {
        this.tipoDocumento = this.modalRef.componentInstance.tipoDocumento;
    }

    atualizar() {
        this.update(this.tipoDocumento);
    }

    update(tipoDocumento) {
        this.spinner.show();
        this.toastrService.clear();

        this.tipoDocumentosService.update(tipoDocumento)
            .subscribe(res => {
                this.toastrService.success("Tipo de documento atualizado!.", "Sucesso");
                this.modalRef.close({ result: true, page: this.modalRef.componentInstance.page, acao: 'atualizado' });
            }, error => {
                if (error && error.errors) {
                    this.toastrService.error(error.errors[0], 'Atenção', { timeOut: 10000 });
                }
                else {
                    this.toastrService.error('Não foi possível atualizar o tipo de documento!', 'Atenção', { timeOut: 10000 });
                }
                this.spinner.hide();
            });
    }

    close() {
        this.modalRef.close();
    }

    dismiss() {
        this.modalRef.dismiss();
    }
}